import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subscription, from } from "rxjs";
import { MediaMatcher } from "@angular/cdk/layout";
import { UserService } from "../../services/Users.service";
import { CallBackService } from "src/app/features/callback/services/CallBack.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";

type CustomerRole = {
  selected: boolean;
  roleName: string;
  id: string;
};
@Component({
  selector: "users-update",
  templateUrl: "./users-update.component.html",
  styleUrls: ["./users-update.component.css"],
})
export class UsersUpdateComponent implements OnInit,OnDestroy {
    public formGroup: FormGroup;
  public clientePlaceholder: string = "Cargando...";
  public isLoading = true;
  //es la variable que contiene los datos de los clientes
  otherCustomers: {
    selected: boolean,
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[];
  //es la variable que contiene los clientes seleccionados en el control y sus datos
  selectedCustomers: {
    selected: boolean,
    number: number, 
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[] = [];
  //es la variable que contiene los datos de los clientes seleccinoados previamente
  updateOtherCustomers: {
    selected: boolean,
    number: number,
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[];
  hidePassword = true;
  extraCustomerCount: number[] = [];
  readonly: boolean = true;
  subscription_GetLoading: Subscription;
  _stringIdentifiers: string;

  public $otherCustomers: Observable<any>;

  subscription_getUpdateUser: Subscription;
  subscription_postUpdateUser: Subscription;
  subscription_getGroups: Subscription;
  subscription_otherCustomers: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private notifyService: SwalNotificationService,
    private routerService: Router,
    private route: ActivatedRoute,
    private callbackService: CallBackService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 1001px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userService.isUpdateUser = true;
    this.subscription_GetLoading = this.userService.getLoading().subscribe((data: boolean) => {
        this.isLoading = data;
      });
    this.$otherCustomers = this.userService.getOtherCustomers();
    this.subscription_otherCustomers = this.$otherCustomers.subscribe((data) => {
      this.otherCustomers = data;
    });
  }

 
  ngOnInit(): void {
    var id: string = this.route.snapshot.queryParamMap.get("Id");
    this.bulidForm();
    this.getUpdateUsers(id);
    this.userService.setLoading(true);
    this.readonly = true;
  }
  ngOnDestroy() {
    if (this.subscription_getUpdateUser) 
      this.subscription_getUpdateUser.unsubscribe();
    if (this.subscription_postUpdateUser) 
      this.subscription_postUpdateUser.unsubscribe();
    if (this.subscription_getGroups) 
      this.subscription_getGroups.unsubscribe();
    if (this.subscription_otherCustomers) 
      this.subscription_otherCustomers.unsubscribe();
  }

  getUpdateUsers(id) {
    this.subscription_getUpdateUser = this.userService.getUpdateUser(id).subscribe((data) => {
      console.log("datos", data);
      
      if (data.isSuccess) {
        this.userService.setLoading(false);

        //aqui se agregan los datos de clientes que ya tiene un usuario
        this.updateOtherCustomers = data.result.user.otherCustomers;
        this.updateOtherCustomers.forEach(customer => {customer.selected = true});
        var i: number = 0;
        this.updateOtherCustomers.forEach(customer => {
          customer.number = i;
          if (i !=0)
            this.extraCustomerCount.push(this.extraCustomerCount.length + 1);
          i++;
        });
        //se agregan los datos de todos los clientes y sus datos correspondientes
        this.otherCustomers = data.result.clientes;
        this.otherCustomers.forEach(customer => {customer.selected = false});
        this.otherCustomers.forEach(customer => {
          if(this.updateOtherCustomers.find(x => x.customerName == customer.customerName) != null)
            customer.selected = true;
        });

        //se agregan los datos generales del usuario
        this.formGroup.controls["id"].patchValue(data.result.user.id);
        this.formGroup.controls["client"].patchValue(this.updateOtherCustomers.filter((x) => x.customerName == data.result.user.client)[0].idCustomer);
        this.formGroup.controls["userName"].patchValue(data.result.user.userName);
        this.formGroup.controls["firstName"].patchValue(data.result.user.firstName);
        this.formGroup.controls["lastName"].patchValue(data.result.user.lastName);
        this.formGroup.controls["secondLastName"].patchValue(data.result.user.secondLastName);
        this.formGroup.controls["email"].patchValue(data.result.user.email);
        this.formGroup.controls["password"].patchValue(data.result.user.password);
        this.formGroup.controls["confirmPassword"].patchValue(data.result.user.password);
        this.formGroup.controls["userNameCitronella"].patchValue(data.result.user.userNameCitronella);
        this.formGroup.controls["isUserAPP"].patchValue(data.result.user.isUserAPP);
        this.formGroup.controls["rol"].patchValue(data.result.user.rol);
        this.formGroup.controls["groups"].patchValue(data.result.user.groups);
        data.result.user.status == "1"? this.formGroup.controls["status"].patchValue(1) : this.formGroup.controls["status"].patchValue(-1); 

        this.showValidationMsg(this.formGroup);

        this.userService.setUpdateOtherCustomers(this.updateOtherCustomers);
        this.userService.setOtherCustomers(this.otherCustomers);
        console.log("formGroup", this.formGroup.value);
        console.log("updateOtherCustomers", this.updateOtherCustomers, "otherCustomers", this.otherCustomers);
      }
    });
    
  }
  
  bulidForm() {
    const myRegex = new RegExp('^(?=.*\\d)(?=.*[A-Z])(?=.*[#$&?/])[a-zA-Z0-9#\$&\?\/]{8,15}$');
    const myRegexNombres = new RegExp('^[a-zA-Z .]+$');
    this.formGroup = this.formBuilder.group({
      id: [""],
      client: ["", Validators.required],
      customers: [this.otherCustomers],
      userName: [""],
      firstName: ["", Validators.compose([Validators.required, Validators.pattern(myRegexNombres)])],
      lastName:  ["", Validators.pattern(myRegexNombres)],
      secondLastName: ["", Validators.pattern(myRegexNombres)],
      email: ["", Validators.compose([Validators.required, Validators.email])],
      password: ["", Validators.compose([Validators.pattern(myRegex)])],
      confirmPassword: ["", Validators.compose([Validators.pattern(myRegex)])],
      userNameCitronella: "",
      isUserAPP: false,
      rol: ["", Validators.required],
      status: [""],
      identifiers: [],
      groups: [[""]],
      subGroups: [[""]]
    }, {
      validator: this.passwordMatchValidator
    });
    
  }

  public onSubmit(users: any, form: HTMLFormElement, formG: FormGroup) {
    //se crea un objeto para no modificar el objeto original
    users.customers = this.otherCustomers;
    const submitUser = JSON.parse(JSON.stringify(users));
    
    // Asignar el cliente default en la posición 0
    submitUser.customers= [];
    submitUser.customers[0] = this.selectedCustomers.find(x => x.number === 0);

    // Filtrar los elementos distintos de 0 y agregarlos al array
    const otherSelectedCustomers = this.selectedCustomers.filter(x => x.number !== 0);
    otherSelectedCustomers.forEach(customer => {
      if (customer.selected) {
        submitUser.customers.push(customer); 
      }
    });

    console.log("submitUser", submitUser);
    if(!this.formGroup.invalid) {
      this.isLoading = true;
      this.subscription_postUpdateUser = this.userService.postUpdateUser(submitUser).subscribe((data) => {
        console.log("data de actualización", data);
        
        if (data.isSuccess) {
          if (data.errors != null && data.errors.length > 0) {
            var erroresSeparadosPorSaltosDeLinea = data.errors.map(function(error) {
              return "- " + error + '\n';
            }).join('');
            this.notifyService.MessageSuccessful(
              "Usuario Actualizado Exitosamente",
              "El usuario fue actualizado exitosamente, pero no se han agregado los siguientes VIN: " + erroresSeparadosPorSaltosDeLinea
            );
            this.isLoading = false;
            this.routerService.navigate(["/users"]);
          }
          else{
            this.notifyService.MessageSuccessful(
              "Usuario Actualizado Exitosamente",
              "El usuario fue actualizado exitosamente"
            );
            this.isLoading = false;
            this.routerService.navigate(["/settingsAdmin"]);
          }
        } else {
          this.notifyService.MessageError(
            data.message
          );
          this.isLoading = false;
        }
      });
    }
    else {
      const formFields = Object.keys(formG.controls);
      const incompleteFields = formFields.filter(field => formG.get(field).invalid && formG.get(field).errors.required);
      return;
    }
  }

  private showValidationMsg(formGroup: FormGroup) {

    for (const key in formGroup.controls) {
        if (formGroup.controls.hasOwnProperty(key)) {
            const control: FormControl = <FormControl>formGroup.controls[key];

            if (Object.keys(control).includes('controls')) {
                const formGroupChild: FormGroup = <FormGroup>formGroup.controls[key];
                this.showValidationMsg(formGroupChild);
            }

            control.markAsTouched();
        }
    }
}

  public getError(controlName: string): string {
    let error = "";
    const control = this.formGroup.get(controlName);
    if (control.touched && control.errors != null) {
      if (control?.errors?.["required"]) error = "Campo Requerido *";
      else if (control?.errors?.["minLength"]) error = "Minimo 8 digitos *";
      else if (control?.errors?.["passwordMismatch"]) error = "Las contraseñas no son iguales";
      else if (control?.errors?.["pattern"]) {
        if (controlName === "firstName" || controlName === "lastName" || controlName === "secondLastName") {
          control.setErrors({ pattern: true });
          error = "Solo se permiten caracteres alfabéticos.";
        } else if (controlName === "password") {
          control.setErrors({ pattern: true });
          error = "Requisitos:" +
            "Al menos un dígito (0-9)." +
            "Al menos una letra mayúscula (A-Z)." +
            "Al menos un símbolo permitido (#,$,&,?,/)." +
            "Letras minúsculas (a-z)." +
            "Entre 8 y 15 caracteres de longitud.";
        }
      }
      else error = JSON.stringify(control.errors);
    }
    return error;
  }

  updateIdentifiers(stringIdentifiers: string) {
    this._stringIdentifiers = stringIdentifiers;
  }

  readOnly(){
    this.readonly = false;
  }

  passwordMatchValidator(form: FormGroup) {
    const passwordControl = form.get('password');
    const confirmPasswordControl = form.get('confirmPassword');
    // console.log("password", passwordControl.value, "confirm", confirmPasswordControl.value);
    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordMismatch: true });
    } else {
      confirmPasswordControl.setErrors(null);
    }
  }

  agregarCliente(){
    if (this.extraCustomerCount.length < (this.otherCustomers.length - 1)) {
      let index = 0;
      if (this.extraCustomerCount.length == 0) {
        index = 1;
      }else{
        index =  Math.max(...this.extraCustomerCount) + 1;
      }
      this.extraCustomerCount.push(index);
    }
  }

  quitarCliente(){
    if (this.extraCustomerCount.length > 0) {
      this.extraCustomerCount.splice(-1, 1);
    }
  }

  DeleteCustomerIndex(selectedNumber: number) {
    const index = this.extraCustomerCount.indexOf(selectedNumber);
    this.extraCustomerCount.splice(index, 1);
  }

  assignCustomerData(customerData: any) {
    if (this.otherCustomers == undefined || this.otherCustomers == null) 
      return;

    console.log('customerData',customerData, customerData.selected, 'otherCustomers',this.otherCustomers);
    //si el cliente es el default, agrega los datos default para que haya verrificación de campos
    if (customerData.number == 0) {
      //si el cliente default tiene la seleccion correcta, se añaden los datos al formulario, si no, se elimina
      if (customerData.selected) {
        this.formGroup.controls["client"].patchValue(this.otherCustomers.find(x => x.customerName == customerData.customerName).idCustomer);
        this.formGroup.controls["rol"].patchValue(customerData.roles[0].id);
        this.formGroup.controls["groups"].patchValue(customerData.groups);
        this.formGroup.controls["subGroups"].patchValue(customerData.subGroups);
        this.formGroup.controls["identifiers"].patchValue(customerData.identifiers);
        console.log('formGroup si',this.formGroup.value);
      }else{
        this.formGroup.controls["client"].patchValue("");
        this.formGroup.controls["rol"].patchValue("");
        this.formGroup.controls["groups"].patchValue("");
        this.formGroup.controls["subGroups"].patchValue("");
        this.formGroup.controls["identifiers"].patchValue("");
        console.log('formGroup no',this.formGroup.value);
      }
      
      //si el cliente seleccionado no se ha añadido a la selección, se añade, si ya existe, se modifica
      if (this.selectedCustomers.find(x => x.number == 0) == null) {
        this.selectedCustomers.push(customerData);
      }else{
        const selectedCustomerZero = this.selectedCustomers.find(x => x.number === 0);

        selectedCustomerZero.customerName = customerData.customerName;
        selectedCustomerZero.idCustomer = customerData.idCustomer;
        selectedCustomerZero.roles = customerData.roles;
        selectedCustomerZero.groups = customerData.groups;
        selectedCustomerZero.identifiers = customerData.identifiers;
        selectedCustomerZero.subGroups = customerData.subGroups;
        selectedCustomerZero.selected = customerData.selected;
      }
    }else{
      //si el cliente seleccionado no se ha añadido a la selección, se añade, si ya existe, se sobreescribe
      if (this.selectedCustomers.find(x => x.number == customerData.number) == null) {
        this.selectedCustomers.push(customerData);
      }else{
        const selectedCustomer = this.selectedCustomers.find(x => x.number == customerData.number);
        selectedCustomer.customerName = customerData.customerName;
        selectedCustomer.idCustomer = customerData.idCustomer;
        selectedCustomer.roles = customerData.roles;
        selectedCustomer.groups = customerData.groups;
        selectedCustomer.identifiers = customerData.identifiers;
        selectedCustomer.subGroups = customerData.subGroups;
        selectedCustomer.selected = customerData.selected;
      }
    }
    console.log('otherCustomers',this.otherCustomers, 'selectedCustomers',this.selectedCustomers);

  }


}
